import { Component } from '@angular/core';
import { YouTubeLiveService } from '../../services/youtube.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-youtube',
  imports: [],
  templateUrl: './youtube.component.html',
  styleUrl: './youtube.component.scss',
})
export class YoutubeComponent {
  id = '';
  youtubeUrl: SafeResourceUrl | undefined;

  constructor(
    private youtubeService: YouTubeLiveService,
    private sanitizer: DomSanitizer
  ) {
    youtubeService.getLatestLiveStream().subscribe((res: string | null) => {
      if (res) {
        this.setVideo(res);
      }
    });
  }

  setVideo(id: string) {
    this.id = id;
    const url = `https://www.youtube.com/embed/${id}`;
    this.youtubeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
